module.exports = __webpack_public_path__ + "static/media/navigation-animate.93474e06.svg";